export default "/assets/website/images/chocolatte.png?89c2f6d1ba6e940929025e599cd19a01";